
<!--<div class="container">-->
<div class="background-div">
  <div class="container">
    <div class="main-div">
      <div class="left-pane">
        <h1 i18n>Join us now</h1>

        <ul class="progress-bar">
          <li [ngClass]="(customerSignupService.currentStep$ | async) === customerSignupService.Step.BASIC_INFO ? 'stop' : ''">
          <li [ngClass]="(customerSignupService.currentStep$ | async) === customerSignupService.Step.EMAIL_CONFIRMATION ? 'stop' : ''">
        </ul>

        <div>
          <router-outlet></router-outlet>
        </div>

        <div class="buttons-div">
          <button class="button-secondary button-with-image" (click)="customerSignupService.backButtonClicked()" [disabled]="customerSignupService.disableBackButton" i18n><div class="i-image-to-flip"><i class="bi bi-arrow-left "></i></div>Back</button>
          <div>
            <button type="submit" class="button-primary button-with-image" (click)="customerSignupService.nextButtonClicked()" [disabled]="customerSignupService.disableNextButton" *ngIf="!customerSignupService.loadingNextButton" i18n>Next<div class="i-image-to-flip"><i class="bi bi-arrow-right"></i></div></button>
            <button class="button-primary" type="button" disabled *ngIf="customerSignupService.loadingNextButton">
              <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
              <span class="visually-hidden" role="status">Loading...</span>
            </button>
          </div>
        </div>
      </div>
      <div class="right-pane"></div>
    </div>
  </div>
</div>
<!--</div>-->
